import $ from "jquery"


class Website {

    hamburger = $('#hamburger')

    loader = $("#loader")

    menu = $( '#top-nav' )
    offsetSticky = 500
    menuSticky = $("#top")

    constructor() {

        this.hamburger.on( 'click' , e => {
            this.clickHamburger()
        })

        $(window).on('load', e => {
            this.loader.fadeOut( 200 )
        })
        
        $(window).on('scroll' , event => {
            this.scroll()
        })
        this.scroll()

    }

    clickHamburger(){
        this.hamburger.toggleClass('active')
        this.menu.toggleClass('active')
    }


    scroll( elt ){
        let y = $(window).scrollTop()
        if (y > this.offsetSticky){
            this.menuSticky.addClass('sticky')
        }else{
            this.menuSticky.removeClass('sticky')
        }
    }
    
}

export {Website};


